import GenericTimerSelectionComponent from './components/GenericTimerSelection/GenericTimerSelectionComponent'
import MyTimersListing from './components/MyTimersList/MyTimersListing'
import { TimerPageContainer } from './components/genericTimerPageStyledComponents'

export default function SelfPracticePage() {
  return (
    <TimerPageContainer>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          maxWidth: '1400px',
          margin: '0 auto',
          gap: '50px',
        }}
      >
        <GenericTimerSelectionComponent />
        <MyTimersListing />
      </div>
    </TimerPageContainer>
  )
}
